export const defaultContent = (
  <>
    <span>400k+ 5-star Prose haircare reviews </span>
    <span>on Review & Refine®</span>
  </>
);

export const noFreeShippingContent = 'Limited offer: free starter kit, only pay for shipping';
export const referralCta = 'Refer a friend. Give $20, get $20';
export const membershipCta = 'Subscribe for 15% off + free products. Cancel anytime.';

export const vanityUrlDailypop =
  'Hi DailyPop Viewers! $10 off your first order will be applied at cart';

export const membershipMultiCategoryCta = 'Save 20% when you subscribe to haircare and skincare';

// User has already a skincare subscription
export const membershipMultiCategoryWithSkincareSubscriptionCta =
  'Save 20% when you also subscribe to haircare';

// User has already a haircare subscription
export const membershipMultiCategoryWithHaircareSubscriptionCta =
  'Save 20% when you also subscribe to skincare';

export const freeCleanserCta = 'Free cleanser + 20% off when you subscribe to skincare';
export const firstOrder50Cta = 'Subscribe to skincare for 50% off your first order';

export const welcomeKitOfferUS = 'Try Custom Skincare for Free ($145 value + free shipping!)';
export const welcomeKitOfferCA = 'Try Custom Skincare for Free ($200 CAD value + free shipping!)';

export const accessoriesPromotion2023BannerText = 'Shop 35% off accessories for a limited time';
